export default "__VITE_PUBLIC_ASSET__193236b5__"